import sketchesVideo from "../Media/Images/FallingPhoneImages/SketchesVid.mp4";

export const Videos: any ={
    sketchesVideo
}